import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import BaseButton from '../../lib/BaseButton';
import { useStyles } from './styles';
const ButtonClose = ({ isEmpty, onClose }) => {
    const ownClasses = useStyles({ isEmpty });
    return (React.createElement(BaseButton, { onClick: isEmpty ? () => null : onClose, classes: { root: ownClasses.root } }, !isEmpty && React.createElement(Icon, { className: ownClasses.icon, icon: ['fal', 'times'] })));
};
export default ButtonClose;
